module.exports = __webpack_public_path__ + "img/twitch.257e9da8.svg";